<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'work',
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        {
          label: '范围',
          name: 'scope_type',
          value: '',
          type: 'select',
          dropList: [
            { value: 1, name: '全部小区' },
            { value: 2, name: '指定小区' },
          ],
          rules: [{ required: true, trigger: 'blur', type: 'number' }],
          onChange: this.onselect,
        },
        { label: '所属小区', name: 'community_id', value: '', type: 'select', dropList: [], rules: [{ required: true, trigger: 'blur', type: 'number' }] },
        { label: '分类', name: 'category_id', value: '', type: 'tree', dropList: [], rules: [{ required: true, trigger: 'blur', type: 'number' }] },
        { label: '标题', name: 'title', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        { label: '小标题', name: 'stitle', value: '', type: 'input' },
        { label: '图片', name: 'image', value: '', type: 'image', desc: '图片尺寸最低750*577像素比例', rules: [{ required: true, trigger: 'blur' }] },
        // {label: '链接', name: 'url', value: '',  type: 'input', },
        // { label: "服务标签", name: "keyword", value: "", type: "input" },
        { label: '营业时间', name: 'open_time', value: '', type: 'input' },
        { label: '服务费用', name: 'fee_name', value: '', type: 'input' },
        { label: '联系人', name: 'linkman_name', value: '', type: 'input' },
        { label: '手机号', name: 'linkman_mobile', value: '', type: 'input' },
        { label: '联系公司', name: 'linkman_company', value: '', type: 'input' },
        { label: '联系地址', name: 'address', value: '', type: 'input' },
        { label: '内容', name: 'content', value: '', type: 'textarea' },

        { label: '详情', name: 'detail', value: '', type: 'editor' },
        { label: '置顶', name: 'is_top', value: '', type: 'switch', trueValue: 1, falseValue: 2 },
        { label: '状态', name: 'status', value: 1, type: 'switch', trueValue: 1, falseValue: 2 },
        { label: '备注', name: 'remark', value: '', type: 'textarea' },
      ],
      forms: {},
    }
  },
  created() {
    // this.loadLevelData()
    // this.loadCommunityDrop()

    // let query = this.$route.query
    // if (query.category_id) {
    //   this.forms.category_id = query.category_id
    // }

    // // !非管理员必须选小区
    // if (!this.isRoot) {
    //   this.items[this.getItemIndex('scope_type')].value = 2
    //   this.items[this.getItemIndex('scope_type')].disabled = true
    // }
  },
  methods: {
    // onselect(val) {
    //   if (val == 1) {
    //     // this.items[2].type = 'kong'
    //     this.items[this.getItemIndex('community_id')].type = 'kong'
    //     this.forms.community_id = ''
    //   }
    //   if (val == 2) {
    //     //  this.items[2].type = 'select'
    //     this.items[this.getItemIndex('community_id')].type = 'select'
    //   }
    // },
    // initData() {
    //   // 加载详情数据
    //   $form.initData(this, {}, (res) => {
    //     if (res.scope_type == 1) {
    //       // this.items[2].type = 'kong'
    //       this.items[this.getItemIndex('community_id')].type = 'kong'
    //       this.forms.community_id = ''
    //     }
    //     if (res.scope_type == 2) {
    //       //  this.items[2].type = 'select'
    //       this.items[this.getItemIndex('community_id')].type = 'select'
    //     }
    //     if (res) {
    //       this.forms = res
    //     }
    //   })
    // },
    // loadLevelData() {
    //   // 通过pk查询字典数据
    //   let q = {}
    //   $utils.api.load('serviceCategoryDropTree', q).then((res) => {
    //     if (res && res.data) {
    //       let ll = res.data
    //       let dropList = []
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index]
    //         let xx = {}
    //         xx.value = element.category_id
    //         xx.name = element.name
    //         xx.children = element.children || []
    //         dropList.push(xx)
    //       }
    //       for (let index = 0; index < this.items.length; index++) {
    //         const element = this.items[index]
    //         if (element && element.name == 'category_id') {
    //           // this.items[index]['dropList'] = dropList
    //           this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
    //         }
    //       }
    //     }
    //   })
    // },
    // loadCommunityDrop() {
    //   // 通过pk查询字典数据
    //   let q = {}
    //   $utils.api.load('communityDrop', q).then((res) => {
    //     if (res && res.data) {
    //       let ll = res.data.list
    //       let dropList = []
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index]
    //         let xx = {}
    //         xx.value = element.community_id
    //         xx.name = element.community_name
    //         dropList.push(xx)
    //       }
    //       for (let index = 0; index < this.items.length; index++) {
    //         const element = this.items[index]
    //         if (element && element.name == 'community_id') {
    //           this.items[index]['dropList'] = dropList
    //         }
    //       }
    //     }
    //   })
    // },
  },
}
</script>
